// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin Management Pages Common Styles */

.management-page {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
}

.management-header {
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.management-header h1 {
  margin: 0 0 8px;
  color: #333;
  font-size: 28px;
}

.management-header p {
  margin: 0;
  color: #666;
}

/* Stats Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 24px;
  border-radius: 12px;
  text-align: center;
}

.stat-card h3 {
  margin: 0 0 10px;
  font-size: 14px;
  font-weight: 500;
  opacity: 0.9;
}

.stat-card .stat-value {
  margin: 0;
  font-size: 36px;
  font-weight: 700;
}

.stat-card.secondary {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.stat-card.success {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.stat-card.warning {
  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
}

/* Role Distribution */
.role-distribution {
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.role-distribution h3 {
  margin: 0 0 20px;
  color: #333;
  font-size: 18px;
}

.role-bars {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.role-bar {
  display: flex;
  align-items: center;
  gap: 15px;
}

.role-label {
  width: 120px;
  font-size: 14px;
  color: #666;
}

.role-bar-container {
  flex: 1 1;
  height: 24px;
  background: #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
}

.role-bar-fill {
  height: 100%;
  border-radius: 12px;
  transition: width 0.3s ease;
}

.role-bar-fill.admin {
  background: linear-gradient(90deg, #667eea, #764ba2);
}

.role-bar-fill.presenter {
  background: linear-gradient(90deg, #f093fb, #f5576c);
}

.role-bar-fill.moderator {
  background: linear-gradient(90deg, #4facfe, #00f2fe);
}

.role-bar-fill.user {
  background: linear-gradient(90deg, #a8edea, #fed6e3);
}

.role-count {
  width: 40px;
  text-align: right;
  font-weight: 600;
  color: #333;
}

/* Filters Bar */
.filters-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
  padding: 15px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.search-box input {
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  width: 300px;
  font-size: 14px;
}

.search-box input:focus {
  outline: none;
  border-color: #667eea;
}

.filter-selects {
  display: flex;
  gap: 10px;
}

.filter-selects select {
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
}

/* Table Container */
.table-container {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table th,
.data-table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.data-table th {
  font-weight: 600;
  color: #666;
  font-size: 12px;
  text-transform: uppercase;
  background: #f9f9f9;
}

.data-table tr:hover {
  background: #f9f9f9;
}

/* User Cell */
.user-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
}

/* Role Select */
.role-select {
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
}

.role-select.Administrateur {
  background: #e8e8ff;
  color: #667eea;
  border-color: #667eea;
}

.role-select.Presentateur {
  background: #ffe8f0;
  color: #f5576c;
  border-color: #f5576c;
}

.role-select.moderator {
  background: #e8f8ff;
  color: #4facfe;
  border-color: #4facfe;
}

.role-select.user {
  background: #f0f0f0;
  color: #666;
  border-color: #ddd;
}

/* Status Badges */
.status-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.status-badge.active {
  background: #d4edda;
  color: #155724;
}

.status-badge.inactive {
  background: #f8d7da;
  color: #721c24;
}

.status-badge.verified {
  background: #d4edda;
  color: #155724;
}

.status-badge.unverified {
  background: #fff3cd;
  color: #856404;
}

.status-badge.scheduled {
  background: #cce5ff;
  color: #004085;
}

.status-badge.in-progress {
  background: #fff3cd;
  color: #856404;
}

.status-badge.completed {
  background: #d4edda;
  color: #155724;
}

.status-badge.cancelled {
  background: #f8d7da;
  color: #721c24;
}

/* Action Buttons */
.action-buttons {
  display: flex;
  gap: 5px;
}

.btn-icon {
  padding: 6px 8px;
  background: #f0f0f0;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s;
}

.btn-icon:hover {
  background: #e0e0e0;
}

.btn-icon.btn-danger {
  background: #ffebee;
  color: #c62828;
}

.btn-icon.btn-danger:hover {
  background: #ffcdd2;
}

/* No Data */
.no-data {
  text-align: center;
  padding: 40px;
  color: #999;
  font-size: 16px;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.modal-header h2 {
  margin: 0;
  font-size: 20px;
  color: #333;
}

.modal-close {
  background: none;
  border: none;
  font-size: 28px;
  color: #999;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.modal-close:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
}

.modal-footer {
  padding: 15px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/* User Details */
.user-details {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.detail-row {
  display: flex;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 10px;
}

.detail-label {
  width: 150px;
  font-weight: 600;
  color: #666;
}

.detail-value {
  flex: 1 1;
  color: #333;
  word-break: break-all;
}

/* Buttons */
.btn-primary {
  padding: 10px 20px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-primary:hover {
  background: #5568d3;
}

.btn-secondary {
  padding: 10px 20px;
  background: #f0f0f0;
  color: #333;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-secondary:hover {
  background: #e0e0e0;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
  color: #333;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #667eea;
}

/* Error Message */
.error-message {
  background: #fee;
  border: 1px solid #fcc;
  color: #c33;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 20px;
}

/* Loading */
.admin-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 18px;
  color: #666;
}

/* Responsive */
@media (max-width: 768px) {
  .filters-bar {
    flex-direction: column;
    align-items: stretch;
  }

  .search-box input {
    width: 100%;
  }

  .filter-selects {
    flex-direction: column;
  }

  .role-bar {
    flex-direction: column;
    align-items: stretch;
  }

  .role-label {
    width: 100%;
  }

  .role-count {
    text-align: left;
  }

  .data-table {
    font-size: 12px;
  }

  .data-table th,
  .data-table td {
    padding: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/AdminManagement.css"],"names":[],"mappings":"AAAA,yCAAyC;;AAEzC;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,WAAW;EACX,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;AACF","sourcesContent":["/* Admin Management Pages Common Styles */\r\n\r\n.management-page {\r\n  max-width: 1400px;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n}\r\n\r\n.management-header {\r\n  margin-bottom: 30px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.management-header h1 {\r\n  margin: 0 0 8px;\r\n  color: #333;\r\n  font-size: 28px;\r\n}\r\n\r\n.management-header p {\r\n  margin: 0;\r\n  color: #666;\r\n}\r\n\r\n/* Stats Grid */\r\n.stats-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n  gap: 20px;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.stat-card {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n  padding: 24px;\r\n  border-radius: 12px;\r\n  text-align: center;\r\n}\r\n\r\n.stat-card h3 {\r\n  margin: 0 0 10px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  opacity: 0.9;\r\n}\r\n\r\n.stat-card .stat-value {\r\n  margin: 0;\r\n  font-size: 36px;\r\n  font-weight: 700;\r\n}\r\n\r\n.stat-card.secondary {\r\n  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\r\n}\r\n\r\n.stat-card.success {\r\n  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);\r\n}\r\n\r\n.stat-card.warning {\r\n  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);\r\n}\r\n\r\n/* Role Distribution */\r\n.role-distribution {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 24px;\r\n  margin-bottom: 30px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.role-distribution h3 {\r\n  margin: 0 0 20px;\r\n  color: #333;\r\n  font-size: 18px;\r\n}\r\n\r\n.role-bars {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n}\r\n\r\n.role-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 15px;\r\n}\r\n\r\n.role-label {\r\n  width: 120px;\r\n  font-size: 14px;\r\n  color: #666;\r\n}\r\n\r\n.role-bar-container {\r\n  flex: 1;\r\n  height: 24px;\r\n  background: #f0f0f0;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n}\r\n\r\n.role-bar-fill {\r\n  height: 100%;\r\n  border-radius: 12px;\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.role-bar-fill.admin {\r\n  background: linear-gradient(90deg, #667eea, #764ba2);\r\n}\r\n\r\n.role-bar-fill.presenter {\r\n  background: linear-gradient(90deg, #f093fb, #f5576c);\r\n}\r\n\r\n.role-bar-fill.moderator {\r\n  background: linear-gradient(90deg, #4facfe, #00f2fe);\r\n}\r\n\r\n.role-bar-fill.user {\r\n  background: linear-gradient(90deg, #a8edea, #fed6e3);\r\n}\r\n\r\n.role-count {\r\n  width: 40px;\r\n  text-align: right;\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n\r\n/* Filters Bar */\r\n.filters-bar {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 20px;\r\n  margin-bottom: 20px;\r\n  padding: 15px;\r\n  background: white;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.search-box input {\r\n  padding: 10px 15px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  width: 300px;\r\n  font-size: 14px;\r\n}\r\n\r\n.search-box input:focus {\r\n  outline: none;\r\n  border-color: #667eea;\r\n}\r\n\r\n.filter-selects {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.filter-selects select {\r\n  padding: 10px 15px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Table Container */\r\n.table-container {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 20px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  overflow-x: auto;\r\n}\r\n\r\n.data-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\n\r\n.data-table th,\r\n.data-table td {\r\n  padding: 12px 15px;\r\n  text-align: left;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.data-table th {\r\n  font-weight: 600;\r\n  color: #666;\r\n  font-size: 12px;\r\n  text-transform: uppercase;\r\n  background: #f9f9f9;\r\n}\r\n\r\n.data-table tr:hover {\r\n  background: #f9f9f9;\r\n}\r\n\r\n/* User Cell */\r\n.user-cell {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.user-avatar {\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 50%;\r\n  background: linear-gradient(135deg, #667eea, #764ba2);\r\n  color: white;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n}\r\n\r\n/* Role Select */\r\n.role-select {\r\n  padding: 6px 10px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n}\r\n\r\n.role-select.Administrateur {\r\n  background: #e8e8ff;\r\n  color: #667eea;\r\n  border-color: #667eea;\r\n}\r\n\r\n.role-select.Presentateur {\r\n  background: #ffe8f0;\r\n  color: #f5576c;\r\n  border-color: #f5576c;\r\n}\r\n\r\n.role-select.moderator {\r\n  background: #e8f8ff;\r\n  color: #4facfe;\r\n  border-color: #4facfe;\r\n}\r\n\r\n.role-select.user {\r\n  background: #f0f0f0;\r\n  color: #666;\r\n  border-color: #ddd;\r\n}\r\n\r\n/* Status Badges */\r\n.status-badge {\r\n  display: inline-block;\r\n  padding: 4px 10px;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n}\r\n\r\n.status-badge.active {\r\n  background: #d4edda;\r\n  color: #155724;\r\n}\r\n\r\n.status-badge.inactive {\r\n  background: #f8d7da;\r\n  color: #721c24;\r\n}\r\n\r\n.status-badge.verified {\r\n  background: #d4edda;\r\n  color: #155724;\r\n}\r\n\r\n.status-badge.unverified {\r\n  background: #fff3cd;\r\n  color: #856404;\r\n}\r\n\r\n.status-badge.scheduled {\r\n  background: #cce5ff;\r\n  color: #004085;\r\n}\r\n\r\n.status-badge.in-progress {\r\n  background: #fff3cd;\r\n  color: #856404;\r\n}\r\n\r\n.status-badge.completed {\r\n  background: #d4edda;\r\n  color: #155724;\r\n}\r\n\r\n.status-badge.cancelled {\r\n  background: #f8d7da;\r\n  color: #721c24;\r\n}\r\n\r\n/* Action Buttons */\r\n.action-buttons {\r\n  display: flex;\r\n  gap: 5px;\r\n}\r\n\r\n.btn-icon {\r\n  padding: 6px 8px;\r\n  background: #f0f0f0;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.btn-icon:hover {\r\n  background: #e0e0e0;\r\n}\r\n\r\n.btn-icon.btn-danger {\r\n  background: #ffebee;\r\n  color: #c62828;\r\n}\r\n\r\n.btn-icon.btn-danger:hover {\r\n  background: #ffcdd2;\r\n}\r\n\r\n/* No Data */\r\n.no-data {\r\n  text-align: center;\r\n  padding: 40px;\r\n  color: #999;\r\n  font-size: 16px;\r\n}\r\n\r\n/* Modal Styles */\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.modal-content {\r\n  background: white;\r\n  border-radius: 12px;\r\n  width: 90%;\r\n  max-width: 500px;\r\n  max-height: 90vh;\r\n  overflow-y: auto;\r\n}\r\n\r\n.modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 20px;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.modal-header h2 {\r\n  margin: 0;\r\n  font-size: 20px;\r\n  color: #333;\r\n}\r\n\r\n.modal-close {\r\n  background: none;\r\n  border: none;\r\n  font-size: 28px;\r\n  color: #999;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  line-height: 1;\r\n}\r\n\r\n.modal-close:hover {\r\n  color: #333;\r\n}\r\n\r\n.modal-body {\r\n  padding: 20px;\r\n}\r\n\r\n.modal-footer {\r\n  padding: 15px 20px;\r\n  border-top: 1px solid #eee;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 10px;\r\n}\r\n\r\n/* User Details */\r\n.user-details {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n}\r\n\r\n.detail-row {\r\n  display: flex;\r\n  border-bottom: 1px solid #f0f0f0;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.detail-label {\r\n  width: 150px;\r\n  font-weight: 600;\r\n  color: #666;\r\n}\r\n\r\n.detail-value {\r\n  flex: 1;\r\n  color: #333;\r\n  word-break: break-all;\r\n}\r\n\r\n/* Buttons */\r\n.btn-primary {\r\n  padding: 10px 20px;\r\n  background: #667eea;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.btn-primary:hover {\r\n  background: #5568d3;\r\n}\r\n\r\n.btn-secondary {\r\n  padding: 10px 20px;\r\n  background: #f0f0f0;\r\n  color: #333;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.btn-secondary:hover {\r\n  background: #e0e0e0;\r\n}\r\n\r\n.form-group {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.form-group label {\r\n  display: block;\r\n  margin-bottom: 5px;\r\n  font-weight: 500;\r\n  color: #333;\r\n}\r\n\r\n.form-group input,\r\n.form-group select {\r\n  width: 100%;\r\n  padding: 10px 12px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.form-group input:focus,\r\n.form-group select:focus {\r\n  outline: none;\r\n  border-color: #667eea;\r\n}\r\n\r\n/* Error Message */\r\n.error-message {\r\n  background: #fee;\r\n  border: 1px solid #fcc;\r\n  color: #c33;\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n/* Loading */\r\n.admin-loading {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100vh;\r\n  font-size: 18px;\r\n  color: #666;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .filters-bar {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .search-box input {\r\n    width: 100%;\r\n  }\r\n\r\n  .filter-selects {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .role-bar {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .role-label {\r\n    width: 100%;\r\n  }\r\n\r\n  .role-count {\r\n    text-align: left;\r\n  }\r\n\r\n  .data-table {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .data-table th,\r\n  .data-table td {\r\n    padding: 8px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
